/* Copyright 2021, Milkdown by Mirone. */
export const elementIsTag = (element, tagName) => element.tagName === tagName.toUpperCase();
//# sourceMappingURL=element.js.map